import i18n from "@/i18n";

const routes = {
  path: "/tournament",
  name: "Tournament",
  component: () =>
    import(/* webpackChunkName: "tournament" */ "@/views/tournament/Main"),
  children: [
    {
      path: "tournamentlist",
      alias: "",
      name: "TournamentList",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_list"),
        step: [
          i18n.t("page.tournament.tournament"),
          /* i18n.t("page.tournament.tournament_list"), */
        ],
        menu_num: 4,
        location: "/tournament/tournamentlist",
      },
    },
    {
      path: "tournamentview/:tournamentno+",
      name: "TournamentView",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentView"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_info"),
        step: [
          i18n.t("page.tournament.tournament"),
          /* i18n.t("page.tournament.tournament_info"), */
        ],
        menu_num: 4,
        location: "/tournament/tournamentlist",
      },
    },
    {
      path: "tournamentwrite",
      name: "TournamentWrite",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_write"),
        step: [
          i18n.t("page.tournament.tournament"),
          /* i18n.t("page.tournament.tournament_write"), */
        ],
        menu_num: 4,
        location: "/tournament/tournamentlist",
      },
    },
    {
      path: "tournamentwrite/:tournamentno+",
      name: "TournamentModify",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_edit"),
        step: [
          i18n.t("page.tournament.tournament"),
          /* i18n.t("page.tournament.tournament_edit"), */
        ],
        menu_num: 4,
        location: "/tournament/tournamentlist",
      },
    },

    {
      path: "tournamentrank/:tournamentno",
      name: "TournamentRank",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentRank"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_rank"),
        step: [
          i18n.t("page.tournament.tournament"),
          /* i18n.t("page.tournament.tournament_rank"), */
        ],
        menu_num: 4,
        location: "/tournament/tournamentlist",
      },
    },
    {
      path: "tournamentlocations/:tournamentno",
      name: "TournamentLocations",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentLocations"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_location"),
        step: [
          i18n.t("page.tournament.tournament"),
          /* i18n.t("page.tournament.tournament_location"), */
        ],
        menu_num: 4,
        location: "/tournament/tournamentlist",
      },
    },
  ],
};

export default routes;
